"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function validateString(s) {
    return typeof s === 'string' && s.length > 0;
}
exports.validateString = validateString;
function validateEmail(email) {
    if (!validateString(email)) {
        return false;
    }
    var pos = email.indexOf('@');
    return pos > 0 && pos < email.length - 1;
}
exports.validateEmail = validateEmail;
function validatePhone(phone) {
    return validateString(phone) && phone.length > 2;
}
exports.validatePhone = validatePhone;
//# sourceMappingURL=validators.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/bi-logger-sanitizer/dist/src/lib/validators.js
// module id = 226
// module chunks = 0